import PropTypes from 'prop-types';
var PropertyControlledComponent = function PropertyControlledComponent(_ref) {
  var controllerProperty = _ref.controllerProperty,
    children = _ref.children,
    fallback = _ref.fallback;
  if (!controllerProperty) return fallback;
  return children;
};
PropertyControlledComponent.propTypes = {
  controllerProperty: PropTypes.bool,
  fallback: PropTypes.oneOf([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
PropertyControlledComponent.defaultProps = {
  controllerProperty: false,
  fallback: null
};
export default PropertyControlledComponent;